module.exports = EqHeight = function(el){
  this.element = $(el);
  this.item = this.element.find('.js-height-item');
  this.group = this.element.attr('data-eqHeight-cls');
  this.event();
};
EqHeight.prototype.event = function(){
  if(this.group === undefined){
    this.item.matchHeight();
  }else{
    var str = this.group.split(',');
    for(var i = 0; i < str.length; i++){
      var item = $('.' + str[i]);
      this.element.find(item).matchHeight();
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./js/_modules/eqHeight.js
// module id = 3
// module chunks = 0